<template>
  <b-row class="associate-file my-4" align-h="start">
    <b-col lg="6" md="6" cols="12" class="associate-text-container">
      <b-row>
        <b-col cols="9" class="mx-auto">
          <p class="associate-titulo" v-html="content.titulo"></p>
          <p class="associate-subtitulo" v-html="content.subtitulo"></p>
          <div class="mt-5 pb-5">
            <button
              class="button-primary-associate"
              @click="goRouter('/negocio')"
            >
              <span class="button-text-associate"
                >{{ content.button }}
                <img
                  src="@/assets/images/arrow_left.svg"
                  alt="Left Arrow img"
                />
              </span>
            </button>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col lg="5" md="5" cols="6" class="carousel-desktop">
      <VueSlickCarousel
        class="associate-slider w-50 h-50"
        ref="carousel"
        v-bind="settings"
      >
        <!-- <div class="associate-icon text-center center-block" v-for="(i, index) in content.socios" :key="index"><img
                        :src="require(`@/assets/images/${i.image}`)" alt=""></div> -->
        <div
          class="associate-icon text-center center-block"
          v-for="(i, index) in content.socios"
          :key="index"
        >
          <img v-bind:src="i.img_path" class="img-carousel-desktop" alt="" />
        </div>
      </VueSlickCarousel>
    </b-col>
    <b-col cols="12" class="carousel-movil">
      <VueSlickCarousel
        v-if="content"
        class="associate-slider w-50 h-50"
        ref="carousel"
        v-bind="settings"
      >
        <div
          class="associate-icon text-center center-block"
          v-for="(i, index) in content.socios"
          :key="index"
        >
          <img
            v-bind:src="i.img_path_thumb"
            class="associate-icon-movil img-carousel-movil"
            alt=""
          />
        </div>
      </VueSlickCarousel>
    </b-col>
    <b-col lg="1" md="1" style="display: flex" class="carousel-desktop">
      <img
        Class="associate-dot"
        src="@/assets/images/Shape.svg"
        @click="showNext"
        alt="Shape img"
      />
    </b-col>
    <!--<b-row class="carousel-movil">
            <div class="div-carousel-movil" style=" display: flex; width: 150px;">
                <img Class="img-carousel-movil" src="@/assets/images/socio1.png" />
            </div>
            <div class="div-carousel-movil" style=" display: flex; width: 150px;;">
                <img Class="img-carousel-movil" src="@/assets/images/socio2.png" />
            </div>
            <div class="div-carousel-movil" style=" display: flex; width: 150px;">
                <img Class="img-carousel-movil" src="@/assets/images/socio3.png" />
            </div>
            <div class="div-carousel-movil" style=" display: flex; width: 150px;">
                <img Class="img-carousel-movil" src="@/assets/images/socio4.png" />
            </div>
        </b-row>

        <b-row class="carousel-movil">
            <div class="div-carousel-movil" style=" display: flex; width: 150px;">
                <VueSlickCarousel  :arrows="true"  :dots="true" >
                <div> 1 </div>
                <div> 2 </div>
                <div> 3 </div>
                <div> 4 </div>
                </VueSlickCarousel>
            </div>
        </b-row>-->
  </b-row>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";

import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "section-associate",
  components: {
    VueSlickCarousel,
  },
  props: {
    content: Object,
  },
  data: () => ({
    settings: {
      infinite: true,
      slidesToShow: 3,
      rows: 1,
      slidesPerRow: 1,
      slidesToScroll: 3,
      autoplay: true,
      speed: 4000,
      autoplaySpeed: 1500,
      cssEase: "linear",
      rtl: true,
      swipeToSlide: true,
      touchMove: true,
    },
    settings2: {
      infinite: true,
      slidesToShow: 3,
      rows: 1,
      slidesPerRow: 1,
      slidesToScroll: 3,
      autoplay: true,
      speed: 4000,
      autoplaySpeed: 1500,
      cssEase: "linear",
      rtl: true,
      swipeToSlide: true,
      touchMove: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            infinite: true,
            slidesToShow: 2,
            speed: 1500,
            rows: 3,
            slidesPerRow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            infinite: true,
            slidesToShow: 2,
            speed: 5000,
            rows: 3,
            slidesPerRow: 2,
          },
        },
      ],
    },
  }),
  created: function () {
    var self = this;
    setInterval(function () {
      self.settings.rtl = !self.settings.rtl;
    }, 15000);
  },
  mounted: function () {
    // console.log("el contenido : ", this.content)
  },
  methods: {
    showNext() {
      this.$refs.carousel.next();
    },
    goRouter(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style scoped>
.carousel-movil {
  display: none;
  justify-content: center;
  align-items: center;
}

.h-50 {
  height: 150px !important;
}
.w-50 {
  width: 150px !important;
}
.slick-slide > div {
  margin: 0.5rem;
}
.slick-slide li > a {
  padding: 1.25rem;
}

.carousel-desktop {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.img-carousel-desktop {
  width: 150px;
  height: 130px;
  object-fit: cover;
  object-position: center;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  }
}

.slick-slide {
  max-width: 100px;
}
.img-carousel-movil {
  width: 150px;
}

@media (max-width: 600px) {
  .carousel-desktop {
    display: none;
  }

  .carousel-movil {
    display: flex;
  }
}
</style>
